export function authHeader(auth_token, header) {
  header = header || {}; // (merge with existing header if provided
  // return authorization header with auth credentials
  header['Authorization'] = 'Bearer ' + auth_token;
  return header;
}

export function handleResponse(response, no_redirect) {
  return response.json().then(data => {
    if (!response.ok) {
      if (response.status === 401) {
        // auto logout if 401 response returned from api
        if (no_redirect !== true) {
          window.location = "/auth/login"
        }
      }

      const error = (data && data.message) || response.statusText;
      return Promise.reject(error);
    }

    return data;
  });
}

